import React, { useState } from 'react';
import { Platform, StyleSheet, useWindowDimensions, View } from 'react-native';
import { Text, ButtonGroup } from '@rneui/themed';
import { getTabs } from '../../utils/purchase';
import NoPurchaseMessage from './NoPurchaseMessage';
import { PurchaseableCard } from './PurchaseableCard';
import { useIsAbleToPurchaseOnStorefront } from '../../hooks';
import { Text as SkeletonText } from '../skeleton';
const ExternalStoreIDMap = {
    apple: 'ios',
    google: 'android',
};
const STACK_OPTIONS_BRAKEPOINT = 500;
export const PurchaseOptions = ({ isError, isLoading, products, subscriptions, rentals, }) => {
    const [index, setIndex] = useState(0);
    const { isAble: isAbleToPurchase, isLoading: isLoadingAbility, } = useIsAbleToPurchaseOnStorefront();
    const { width } = useWindowDimensions();
    if (isError) {
        return (React.createElement(React.Fragment, null,
            React.createElement(Text, { h1: true }, "Oh no!"),
            React.createElement(Text, null, "Something went wrong. Please contact support.")));
    }
    if (isLoading) {
        return (React.createElement(Text, null, "Loading..."));
    }
    if (products.length === 0 && subscriptions.length === 0) {
        return (React.createElement(React.Fragment, null,
            React.createElement(Text, { h1: true }, "Uh oh!"),
            React.createElement(Text, { style: { marginTop: 5 } }, "It looks like there's currently no way to buy this product. Please contact support to get this fixed.")));
    }
    const eligibleProducts = products.filter((p) => {
        return (isAbleToPurchase ||
            p.externalIdentifiers?.some((id) => {
                return Platform.OS === ExternalStoreIDMap[id.store];
            }));
    });
    const eligibleSubscriptions = subscriptions.filter((s) => {
        return (isAbleToPurchase ||
            s.externalIdentifiers?.some((id) => {
                return Platform.OS === ExternalStoreIDMap[id.store];
            }));
    });
    if (!isAbleToPurchase &&
        eligibleProducts.length === 0 &&
        eligibleSubscriptions.length === 0) {
        return React.createElement(NoPurchaseMessage, null);
    }
    const tabs = getTabs({ products, subscriptions, rentals });
    return (React.createElement(View, { style: {
            width: '100%',
            minWidth: 300,
            alignItems: 'center',
        } }, isLoadingAbility === true ? (React.createElement(React.Fragment, null,
        React.createElement(SkeletonText, { lineWidth: "35%" }),
        React.createElement(SkeletonText, { lineWidth: "100%" }),
        React.createElement(SkeletonText, { lineWidth: "87%" }))) : (React.createElement(React.Fragment, null,
        tabs.length > 1 ? (React.createElement(ButtonGroup, { buttons: tabs.map((tab) => tab.title), selectedIndex: index, onPress: (value) => setIndex(value), buttonStyle: styles.buttonStyle, buttonContainerStyle: styles.buttonContainerStyle, selectedButtonStyle: styles.selectedButtonStyle, containerStyle: styles.containerStyle })) : null,
        tabs.map((tab, i) => i === index ? (React.createElement(View, { key: tab.title, style: {
                flexDirection: width >= STACK_OPTIONS_BRAKEPOINT ? "row" : "column",
                alignContent: "space-between",
                paddingBottom: 10,
                rowGap: 10,
                maxWidth: tab.purchasables.length * 500,
            } }, tab.purchasables.map((p) => (React.createElement(View, { key: p.id, style: {
                flex: width < STACK_OPTIONS_BRAKEPOINT ? undefined : 1,
            } },
            React.createElement(PurchaseableCard, { purchaseable: p, descriptionMaxHeight: tab.purchasables.length > 1
                    && width < STACK_OPTIONS_BRAKEPOINT
                    ? 75 : undefined })))))) : null)))));
};
const styles = StyleSheet.create({
    buttonStyle: {
        backgroundColor: 'transparent',
        borderWidth: 0,
        paddingHorizontal: 12,
    },
    buttonContainerStyle: {
        flex: undefined,
        minWidth: 80,
        backgroundColor: 'rgba(192, 192, 192, 0.25)',
        borderWidth: 0,
        borderRightWidth: 0,
        padding: 8,
    },
    selectedButtonStyle: {
        borderRadius: 6,
        shadowColor: 'black',
        shadowRadius: 5,
        shadowOpacity: 0.5,
    },
    containerStyle: {
        height: 48,
        borderRadius: 8,
        marginBottom: 20,
        borderWidth: 0,
        backgroundColor: 'transparent',
    },
});
//# sourceMappingURL=PurchaseOptions.js.map